module.exports = __webpack_public_path__ + "img/44_29.b04d1bbf.png";